<template>
  <div class="quote-detail flex-column">
    <!--    当前报价-->
    <div class="card">
      <div class="section current-quote">
        <base-section-title class="section-title" title="当前报价" />

        <div class="quote-card-wrap flex-center">
          <div
            class="quote-card flex-column flex-center"
            :class="{ inactive: !Number(currentAmount) }"
          >
            <span>
              {{
                Number(currentAmount)
                  ? strToThousands(currentAmount)
                  : '暂无数据'
              }}
            </span>
            <div style="text-align: center">
              <money-in-cn :money="currentAmount" />
            </div>
            <span>当前报价（元）</span>
          </div>
          <div
            class="quote-card flex-column flex-center"
            :class="{ inactive: !currentSupplier }"
          >
            <span :style="`font-size: ${quoteNameSize / 16}rem`">
              {{ currentSupplier ? currentSupplier : '暂无数据' }}
            </span>
            <span>当前报价方</span>
          </div>
        </div>

        <div class="quote-btn-group flex-center">
          <el-button
            v-if="roles === 'supplier'"
            type="primary"
            size="small"
            @click="seeQuoteDetail"
          >查看竞价单信息</el-button>
          <el-button
            type="primary"
            size="small"
            @click="competeHistoryDialog = true"
          >查看竞价记录</el-button>
        </div>
      </div>
    </div>

    <!--    竞价排名-->
    <div class="card flex-column quote-ranking">
      <div class="section quote-ranking-content">
        <base-section-title class="section-title" title="竞价排名" />

        <el-table
          v-if="rankingList.length"
          border
          highlight-current-row
          style="width: 100%"
          header-row-class-name="table-header"
          :data="rankingList"
          size="medium"
          height="230px"
        >
          <el-table-column
            label="排名"
            prop="index"
            align="center"
            type="index"
            width="60"
          />
          <el-table-column label="报价方" align="center" min-width="100">
            <template slot-scope="{ row }">
              <el-tooltip
                effect="dark"
                :content="row.supplierName"
                placement="top"
              >
                <div class="text-ellipsis">
                  {{ row.supplierName || ' - ' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="最新报价（元）"
            align="right"
            header-align="center"
            min-width="80"
          >
            <template slot-scope="{ row }">
              <div class="text-ellipsis">
                {{ strToThousands(row.offerAmount || ' - ') }}
              </div>
              <money-in-cn :money="row.offerAmount" />
            </template>
          </el-table-column>
          <el-table-column
            label="幅度（元）"
            align="right"
            header-align="center"
            min-width="60"
          >
            <template slot-scope="{ row }">
              <div class="text-ellipsis">
                {{ strToThousands(row.offerRange || ' - ') }}
              </div>
              <money-in-cn :money="row.offerRange" />
            </template>
          </el-table-column>
          <el-table-column label="报价时间" align="center" min-width="100">
            <template slot-scope="{ row }">
              <div class="text-ellipsis">{{ row.offerTime || ' - ' }}</div>
            </template>
          </el-table-column>
        </el-table>

        <div v-else class="ranking-no-content flex-center">暂无相关数据</div>
      </div>
    </div>

    <compete-history
      v-model="competeHistoryDialog"
      :promise-fun="getCompeteHistoryList"
    />
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import CompeteHistory from '@/components/compete/CompeteHallComponents/CompeteHistory'
import MoneyInCn from '@/components/common/MoneyInCn'
// 引入历史记录api接口
import { getCompeteHistoryListApi } from '@/api/compete'
// 工具方法
import { strToThousands } from '@/utils/utils'

export default {
  name: 'QuoteDetail',

  components: { BaseSectionTitle, CompeteHistory, MoneyInCn },

  props: {
    rankingList: {
      type: Array,
      default: () => []
    },
    roles: {
      type: String,
      default: 'procure'
    },
    currentAmount: {
      type: String,
      default: ''
    },
    currentSupplier: {
      type: String,
      default: ''
    },
    routerName: {
      type: String,
      default: ''
    },
    orderId: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      quoteNameSize: 42,
      competeHistoryDialog: false
    }
  },

  watch: {
    currentSupplier(val) {
      if (val.length) {
        this.tuneQuoteCompanyNameSize()
      }
    }
  },

  created() {
    this.tuneQuoteCompanyNameSize()
  },

  methods: {
    strToThousands,

    // 暂时当前报价供应商名称时，通过字数的多少控制显示的字体大小
    tuneQuoteCompanyNameSize() {
      const name = this.currentSupplier

      if (name.length <= 6) {
        this.quoteNameSize = 42
      } else if (name.length <= 12) {
        this.quoteNameSize = 30
      } else {
        this.quoteNameSize = 24
      }
    },

    seeQuoteDetail() {
      this.$emit('routerJump')
    },

    // 请求竞价历史（返回Promise）
    getCompeteHistoryList(params) {
      return getCompeteHistoryListApi(
        params,
        this.orderId,
        this.$route.params.token
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.quote-detail {
  flex: 1;

  .current-quote {
    flex: 13;

    .quote-card-wrap {
      margin: 0 pixel-to-rem($n: 20);

      .quote-card {
        flex: 1;
        height: pixel-to-rem($n: 242);
        border-radius: pixel-to-rem($n: 8);
        background-color: #dfefff;
        padding: 0 pixel-to-rem($n: 10);

        & > span:first-child {
          font-size: pixel-to-rem($n: 42);
          @include text-bold;
          color: $primary-color;
          text-align: center;
        }

        & > span:last-child {
          color: $text-color;
          margin-top: pixel-to-rem($n: 16);
        }

        & + .quote-card {
          margin-left: pixel-to-rem($n: 10);
        }

        &.inactive {
          background-color: $grey-background-color;

          & > span:first-child {
            color: $second-text-color;
          }

          & > span:last-child {
            color: $third-text-color;
          }
        }
      }
    }

    .quote-btn-group {
      margin-top: pixel-to-rem($n: 30);
    }
  }

  .quote-ranking {
    flex: 15;

    .quote-ranking-content {
      margin: 0 pixel-to-rem($n: 20);
      flex: 1;

      .ranking-no-content {
        height: 90%;
        font-size: pixel-to-rem($n: 22);
        color: $third-text-color;
        background-color: $grey-background-color;
      }
    }
  }
}
</style>
